import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

/** "Need help? Contact us" under a page in the auth shell. */
@Component({
  selector: 'app-auth-help',
  templateUrl: './auth-help.component.html',
  imports: [TranslocoModule],
  host: {
    class: 'mt-6 block text-center text-13 tracking-tight text-zinc-500',
  },
})
export class AuthHelpComponent {}
